import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface ProfiletunesCategoryCSSStyle extends CRBTUICSSStyle
{
  
}

export class  ProfiletunesCategoryCSSStyleImpl extends CRBTUICSSStyleImpl implements ProfiletunesCategoryCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            height:'100%',
            display:'flex',
            marginTop: "0px",
            justifyContents: "center",
            flexDirection: "row",
            flexFlow: "row wrap"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/profiletunes/profiletunescss.tsx